// extracted by mini-css-extract-plugin
export var root = "project-preview-module--root--wfIAY";
export var wrapper = "project-preview-module--wrapper--Z9jva";
export var text = "project-preview-module--text--UZ-Km";
export var button = "project-preview-module--button--luEJ-";
export var title = "project-preview-module--title--04c-s";
export var link = "project-preview-module--link--+Livy";
export var leadMediaThumb = "project-preview-module--leadMediaThumb---5Zp+";